<div class="product-details--list">
  <div class="product-details--list-specs">
    <h2 class="mb-3">Product Details</h2>
    <div class="product-details__list">
      <ul>
        <li *ngFor="let spec of product.getSpecs(); let i = index">
          <ng-container *ngIf="isLink(spec.key)">
            <span><strong>{{spec.key | translate}}:</strong>&nbsp;<a class="link link-underline text-transformation-none font-weight-normal" href="#" (click)="navigateTo(spec.key, spec.value)"><span [innerHTML]="spec.value | safeContent"></span></a></span>
          </ng-container>
          <ng-container *ngIf="!isLink(spec.key)">
            <span *ngIf="spec.key !== 'TARIFF_PCT'"><strong>{{spec.key | translate}}:</strong>&nbsp;<span [innerHTML]="spec.value | safeContent"></span></span>
            <span *ngIf="spec.key === 'TARIFF_PCT'"><strong>SUBJECT TO TARIFF</strong></span>
          </ng-container>
        </li>
<!--        <li>-->
<!--          <span><strong>Vendor Information:</strong>&nbsp;<span><app-vendor-modal [vendorLabel]="vendorLabel" class="vendor&#45;&#45;container"></app-vendor-modal></span></span>-->
<!--        </li>-->
      </ul>
    </div>
  </div>

  <div class="product-details--list-description">
      <div [innerHTML]="(product?.content?.description || '')| safeContent "></div>
      <div *ngIf="eudrFooterMessage" class="mt-2 pt-2 border-top" role="alert">
          {{ eudrFooterMessage }}
      </div>
  </div>
</div>
